import { IsBottomFromDirector } from './IsBottomFromDirector';
import { IsBottomFromOperator } from './IsBottomFromOperator';
import { IsBottomFromTechnician } from './IsBottomFromTechnician';
import { IsBottomFromTechnicianCoordinator } from './IsBottomFromTechnicianCoordinator';
import { IsSuperAdmin } from './IsSuperAdmin';
import { IsTechnicianOrAbove } from './IsTechnicianOrAbove';
import { IsTenantAdministrator } from './IsTenantAdministrator';
import { IsTenantCoordinator } from './IsTenantCoordinator';
import { IsTenantTechican } from './IsTenantTechican';
import { IsTenantTechnicianCoordinatorOrAbove } from './IsTenantTechnicianCoordinatorOrAbove';

export const PermissionWrappers = {
  superAdmin: IsSuperAdmin,
  tenantAdmin: IsTenantAdministrator,
  operator: IsBottomFromOperator,
  tenantCoordinator: IsTenantCoordinator,
  tenantTechican: IsTenantTechican,

  // Condizioni logiche "OrAbove" / "BottomFrom"
  technicianOrAbove: IsTechnicianOrAbove,
  tenantTechnicianCoordinatorOrAbove: IsTenantTechnicianCoordinatorOrAbove,
  bottomFromDirector: IsBottomFromDirector,
  bottomFromOperator: IsBottomFromOperator,
  bottomFromTechnician: IsBottomFromTechnician,
  bottomFromTechnicianCoordinator: IsBottomFromTechnicianCoordinator
} as const;

export type RequiredPermission = keyof typeof PermissionWrappers;
